import { Dialog, IconButton, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import '../../../assets/style/styleModalList.css';

import { InvoiceForm } from './InvoceForm';

export const InvoiceModalNuevo = ({ title, open, setOpen, initialState, loadIniBudget }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // móvil: sm o menor

    return (
        <Dialog
            // className='dialogModalList'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
            PaperProps={{
                className: isMobile ? '' : 'min-w-fit'
            }}
        >
            <div className='ContainerDialogs'>
                <h1 className='TitleModalPresupuesto'>
                    {title}
                    <IconButton
                        style={{ padding: '0', float: 'right' }}
                        aria-label="close"
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </h1>

                <InvoiceForm
                    initialState={initialState}
                    loadIniBudget={loadIniBudget}
                    setOpen={setOpen}
                />

            </div>
        </Dialog>
    )
}
